export default location.hostname === 'localhost' ? '://localhost:8081/server/' : 's://' + location.hostname + '/server/';
